import React from 'react';
import { motion } from 'framer-motion';
import { processSteps } from '../data/reasons';
import { Reveal } from './Reveal';
import { Eyebrow } from './Eyebrow';
export function Process() {
  return <section className="bg-cream py-24 sm:py-32" data-id="element-274" data-mp="1yep2e89lenxm">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8" data-id="element-275" data-mp="1yg06k96y9xp9">
        <Reveal data-id="element-276" data-mp="23d8nk6gd3vox">
          <div className="max-w-2xl" data-id="element-277" data-mp="23d0764l1688z">
            <Eyebrow data-id="element-278" data-mp="23bxhfzzg2bun">How It Works</Eyebrow>
            <h2 className="mt-6 font-display text-[clamp(2.1rem,5vw,3.6rem)] leading-[1.02] tracking-[-0.02em] text-navy-900" data-id="element-279" data-mp="16p2dh40o8b39">
              Simple From Start
              <span className="block italic text-brass-dark" data-id="element-280" data-mp="1fopgtvcynqyy">to Finish.</span>
            </h2>
          </div>
        </Reveal>

        <div className="relative mt-16" data-id="element-281" data-mp="1kfpbsv2iryyt">
          <motion.div initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 1.4,
          ease: [0.22, 1, 0.36, 1]
        }} className="absolute left-0 right-0 top-7 hidden h-px origin-left bg-navy-900/15 lg:block" aria-hidden="true" data-id="element-282" data-mp="1kgqot533ivj6" />
          <ol className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8" data-id="element-283" data-mp="15je0sn4zkuv5">
            {processSteps.map((step, i) => <Reveal key={step.number} delay={i * 0.12} data-id="element-284" data-mp="10rcqv7vajg8a" data-mpi={i}>
                <li className="relative" data-id="element-285" data-mp="vucl6y2csfhp">
                  <div className="flex items-center gap-4" data-id="element-286" data-mp="vtb4oe2kj0sl">
                    <motion.span initial={{
                  scale: 0.7,
                  opacity: 0
                }} whileInView={{
                  scale: 1,
                  opacity: 1
                }} viewport={{
                  once: true,
                  amount: 0.6
                }} transition={{
                  delay: 0.15 + i * 0.12,
                  duration: 0.5,
                  ease: [0.22, 1, 0.36, 1]
                }} className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-brass/40 bg-cream font-mono text-sm text-brass-dark" data-id="element-287" data-mp="quzxyc7kl6el">
                      {step.number}
                    </motion.span>
                    <span className="h-px flex-1 bg-navy-900/10 lg:hidden" aria-hidden="true" data-id="element-288" data-mp="2v4b9cr5duxra" />
                  </div>
                  <h3 className="mt-6 font-display text-2xl tracking-[-0.01em] text-navy-900" data-id="element-289" data-mp="2hdg9u5grxt0d">
                    {step.title}
                  </h3>
                  <p className="mt-3 max-w-xs text-[15px] leading-relaxed text-ink-700/70" data-id="element-290" data-mp="2mc9d752ck3mt">
                    {step.description}
                  </p>
                </li>
              </Reveal>)}
          </ol>
        </div>
      </div>
    </section>;
}